export function formatBlogDate(dateString: string): string {
  // Create a UTC date object
  const date = new Date(dateString);
  
  // Check if running on mobile
  const isMobile = typeof window !== 'undefined' && 
    window.matchMedia('(max-width: 768px)').matches;

  if (isMobile) {
    // For mobile, use UTC date components to build the string manually
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    
    const year = date.getUTCFullYear();
    const month = months[date.getUTCMonth()];
    const day = date.getUTCDate();
    
    return `${month} ${day}, ${year}`;
  }

  // For desktop, keep the existing behavior
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC'
  }).format(date);
} 